var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridIconSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.828 11.545H12.42v5.408h5.408v-5.408zM9.33 11.545H3.922v5.408H9.33v-5.408zM17.828 3.047H12.42v5.408h5.408V3.047zM9.33 3.047H3.922v5.408H9.33V3.047z",
    stroke: "#1B264F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/icons/gridIconSelected-31ef805e.svg";
export { SvgGridIconSelected as ReactComponent };